import React, { ReactElement } from 'react';

import { HashTag } from '../../../../../types/entity.types';

import './tribe-hashtags.scss';

type Props = {
  hashtags?: HashTag[];
};

const TribeHashtags = ({ hashtags = [] }: Props): ReactElement => {
  if (hashtags.length === 0) {
    return <React.Fragment />;
  }

  return (
    <div className="tribe-hashtags" data-testid="tribe-hashtags">
      <p className="tribe-hashtags__header">Hashtags</p>
      {hashtags.map(
        (hashtag: HashTag, index: number): ReactElement => (
          <div className="tribe-hashtags__hashtag" key={index} data-testid="tribe-hashtag">
            <p className="tribe-hashtags__hashtag__name">{hashtag.name}</p>
            <p className="tribe-hashtags__hashtag__count">
              {hashtag.occurrence && `${hashtag.occurrence} ${hashtag.occurrence === '1' ? 'post' : 'posts'}`}
            </p>
          </div>
        )
      )}
    </div>
  );
};

export default TribeHashtags;
